import { SolarOrientationOption } from './technical-resource'

export const REGIME = 'MW'

export const PRODUCT = {
  SMALL_DV: 'smallDV',
  LARGE_DV: 'largeDV',
} as const

export type Product = (typeof PRODUCT)[keyof typeof PRODUCT]
export type ServiceFeeUnit = 'EUR/Month' | 'EUR/MWh'
export type RedispatchSettlement =
  | 'Übernahme des bisherigen RD 2.0 Abrechnungsmodells (Pauschal oder SpitzLight)'
  | 'Übernahme des bisherigen RD 2.0 Abrechnungsmodells'
  | 'Pauschalabrechnung'

export enum Compensation {
  NOT_APPLICABLE = 'not applicable',
  MARKET_VALUE = 'Market value',
  APPLICABLE_VALUE = 'Applicable value',
}

export interface PriceRequest {
  product: Product
  contractNumber: string
  contract: {
    contractStart: string
    contractEnd: string
    directMarketingType: 'promoted' | 'marketing' | 'other'
    // Herkunftsnachweis (Guarantee of Origin) for renewable energy
    gooMarketing: boolean
  }
  productConfiguration: {
    p51NumberOfHours: number | undefined
    p51CompensationMethod: Compensation
    sharePercentage?: number
    // Anteil Monatsmarktwert
    monthlyMarketValueShare: 0 | 1
    // Anteil Spotpreis
    spotPriceShare: 0 | 1
    // Anteil Fixpreis
    fixedPriceShare: number
    // DLE Leistungspreis applies only to smallDV up to and including 0.75 MW installed capacity
    dleCapacityPriceEurPerMonth: boolean
    // DLE Arbeitspreis applies only to smallDV above 0.75 MW installed capacity
    dleEnergyPriceEurPerMWh: boolean
    //Einheit Dienstleistungsentgelt (EUR/MWh, EUR/Monat)
    serviceFeeUnit: ServiceFeeUnit
    // Other compensation
    compensationType: Compensation
    // Redispatch Abrechnung
    redispatchSettlement: RedispatchSettlement
    remunerationType: 'Marktwert' | 'Spot'
    regime: 'MW' | 'Fix' | 'Spot' | 'Floor'
  }
  technicalresources: {
    installedCapacity: number
    latitude: string
    longitude: string
    commissioningDate: string
    applicableValue?: number
    manufacturer?: string
    turbineType?: string
    hubHeight?: number
    orientation?: SolarOrientationOption
    inclination?: number
    bifacial?: boolean
    tracking?: boolean
  }[]
  productionTechnology: 'solar' | 'wind'
  //Eigenverbrauch in Prozent (smallDV only)
  ownConsumptionPercent?: number
}

export interface PriceResponse {
  pricingId: string
  state: 'Completed' | 'Pending' | 'Failed'
  result?: {
    service_provider_fee_eur_per_mwh: number
    service_provider_fee_eur_per_month: number
    fixed_price_eur_mwh: number
    goo_price_eur_mwh: number
  }
}

export function getServiceProviderFee(response: PriceResponse, unit: ServiceFeeUnit): number | null {
  if (!response.result) return null
  return unit === 'EUR/Month'
    ? response.result.service_provider_fee_eur_per_month
    : response.result.service_provider_fee_eur_per_mwh
}
